import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {VoucherDomainsRepository} from './repositories/voucher-domains.repository';
import {VoucherDomainsService} from './services/voucher-domains.service';
import {VoucherDomainsRoutingModule} from './voucher-domains-routing.module';
import {VoucherDomainsComponent} from './voucher-domains.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    VoucherDomainsRoutingModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    SearchBarModule,
  ],
  declarations: [
    VoucherDomainsComponent,
  ],
  providers: [
    VoucherDomainsService,
    VoucherDomainsRepository,
  ],
})

export class VoucherDomainsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-domains/voucher-domains.module.ts